import chat from './chat'
import documents from './documents'
import global from './global'
import wizzard from './homepage'
import news from './news'
import tasksApprovals from './tasksApprovals'
import translate from './translate'
import userAgent from './userAgent'

const dictionaryEN = {
    global,
    wizzard,
    chat,
    documents,
    tasksApprovals,
    translate,
    userAgent,
    news,
}

export default dictionaryEN
